import React, { memo, useCallback } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import Logo from 'design-system/Logo';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import BottomPanel from 'design-system/BottomPanel';
import { IconClose } from 'design-system/icons/IconClose';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useFundPickerStore, { removeFund, saveFundPicker } from 'features/invest/hooks/useFundPickerStore';
import { useStockMeta } from '../hooks';
const PickedItem = ({ assetId }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { iconUrl } = useStockMeta(assetId) || {};
    return (<View style={styles.logoWrapper}>
      <Logo R44 uri={iconUrl} resizeMode="contain"/>
      <TouchableOpacity style={styles.removeButton} onPress={() => removeFund(assetId)}>
        <IconClose size={6} color={colors.elements.onLight}/>
      </TouchableOpacity>
    </View>);
};
const FundPickerFloatingBar = ({ popCount = 1 }) => {
    const { selectedFunds, mode } = useFundPickerStore();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const handleSave = useCallback(() => {
        saveFundPicker();
        navigation.pop(popCount);
    }, [navigation, popCount]);
    if (mode === 'single')
        return null;
    return (<BottomPanel>
      {selectedFunds.length > 0 && (<>
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.logosRow}>
            {selectedFunds.map((assetId) => (<PickedItem assetId={assetId} key={assetId}/>))}
          </ScrollView>
          <Spacer h={12}/>
        </>)}
      <Button brand title="Save" disabled={selectedFunds.length === 0} onPress={handleSave}/>
    </BottomPanel>);
};
const styleSet = createStyleSheets((colors) => ({
    logosRow: {
        flexDirection: 'row',
    },
    logoWrapper: {
        marginRight: rem(12),
        padding: rem(4),
        overflow: 'visible',
    },
    removeButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: rem(18),
        height: rem(18),
        borderRadius: rem(9),
        backgroundColor: colors.text.negative,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
export default memo(FundPickerFloatingBar);
